import { AppMD5Hash } from "./md5.hash";

export const UUIDGenerator = () => {
  const uuid = Math.random().toString(36).substr(2);
  return AppMD5Hash(uuid);
};
